<template>
  <div class="verify-list-container">
    <div class="title">请确认投保地块信息</div>

    <div class="list-wrapper">
      <common-table
        class="table-wrapper"
        :columns="columns"
        :data="hadSelectedLandList"
        is-scroll
      >
        <template v-slot:landBm="{ row }">
          <span class="crop-name">{{ row.coLandVO.shGisDkid }}</span>
        </template>

        <template v-slot:landName="{ row }">
          <p>
            {{ row.coLandVO.landName }}
          </p>
        </template>

        <template v-slot:landArce="{ row }">
          <p>{{ row.coLandVO.statisticsLandAcre }}亩</p>
        </template>

        <template v-slot:action="{ row }">
          <span class="cancel-select" @click="cancelSelect(row.landId)"
            >取消选择</span
          >
        </template>
      </common-table>
    </div>
    <div class="footer-action-box">
      <el-button class="prev btn" @click="clickPrevStep">上一步</el-button>
      <el-button
        class="next btn"
        type="primary"
        @click="clickNextStep"
        :loading="btnLoading"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
// import { formatDate } from "@/utils";
import { mapGetters, mapState } from "vuex";
import { getInsureDetail } from "@/api/request/snkd.produce";
export default {
  components: { CommonTable },
  data() {
    return {
      btnLoading: false,
      columns: [
        {
          title: "地块编码",
          slot: "landBm",
          className: "crop-col",
        },
        {
          title: "地块名称",
          slot: "landName",
          className: "planting-land",
        },
        {
          title: "地块面积",
          slot: "landArce",
          className: "planting-time",
        },
        {
          title: "操作",
          slot: "action",
          colStyle: {
            flex: 1,
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("ruralInsure", ["hadSelectedLandList"]),
    ...mapState("ruralInsure", ["insureId"]),
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
  },
  methods: {
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.coLandVO.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    // 取消选择
    cancelSelect(landId) {
      if (this.hadSelectedLandList.length === 1) {
        this.$message({
          message: "至少选择1个地块",
          type: "warning",
        });
        return;
      }
      this.$store.commit("ruralInsure/changeSelectStatus", landId);
    },
    clickPrevStep() {
      this.$emit("prev-step", "ChooseLand");
    },
    async clickNextStep() {
      this.btnLoading = true;
      //获取运营平台配置的最小面积
      const res = await getInsureDetail({ id: 2 });
      this.btnLoading = false;
      if (res.respCode == 0) {
        const minInsureLandAcre = res.obj.minInsureLandAcre;
        if (this.totalAcre > minInsureLandAcre) {
          this.$emit("next-step", "Form");
        } else {
          this.$message({
            message: "投保面积不小于" + minInsureLandAcre + "亩",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-list-container {
  position: relative;
  height: 100%;
  background: #ffffff;
  .title {
    font-weight: 600;
    font-size: 22px;
    color: #333333;
    text-align: center;
    padding: 42px 0 12px;
  }
  .list-wrapper {
    height: calc(100% - 84px - 67px);
    margin: 0 30px;
    .table-wrapper {
      height: 100%;
    }
    .cancel-select {
      cursor: pointer;
      color: $--color-primary;
    }
  }
  .footer-action-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 67px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
    .btn {
      width: 122px;
      &.prev {
        margin-right: 14px;
        color: $--color-primary;
        border-color: $--color-primary;
      }
    }
  }
}
</style>
<style lang="scss">
.list-wrapper {
  .crop-col {
    width: 375px;
    box-sizing: border-box;
    padding-left: 25px;
    .crop-img {
      width: 48px;
      height: 48px;
      margin-right: 16px;
    }
  }
  .planting-land {
    width: 400px;
    box-sizing: border-box;
    padding-left: 25px;
    line-height: 20px;
    .unit {
      color: #cccccc;
    }
  }
  .planting-time {
    width: 210px;
    box-sizing: border-box;
    padding-left: 25px;
  }
}
</style>
